import { TraitRegistryText } from '../media/text/TraitRegistryText';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitRegistryImage } from './image/TraitRegistryImage';
import { TraitRegistryMediaSound } from './TraitRegistryMediaSound';
import { TraitRegistryMediaSequence } from './TraitRegistryMediaSequence';
import { TraitRegistryMediaFile } from './TraitRegistryMediaFile';
import { TraitRegistryMediaPlaybackSettings } from './TraitRegistryMediaPlaybackSettings';
import { TraitRegistryMediaTTS } from './TraitRegistryMediaTTS';
import { TraitRegistryMediaVideo } from './TraitRegistryMediaVideo';
import { TraitRegistryMediaHear } from './TraitRegistryMediaHear';
export class TraitRegistryMedia extends TraitRegistryCategory {
    label = 'Media';
    c_image = new TraitRegistryImage(this);
    c_text = new TraitRegistryText(this);
    c_sound = new TraitRegistryMediaSound(this);
    c_seq = new TraitRegistryMediaSequence(this);
    c_mediaFile = new TraitRegistryMediaFile(this);
    c_playbackSettings = new TraitRegistryMediaPlaybackSettings(this);
    c_tts = new TraitRegistryMediaTTS(this);
    c_video = new TraitRegistryMediaVideo(this);
    c_hear = new TraitRegistryMediaHear(this);
}
